import { createQueryHook, TypesForGetRequest } from 'swr-openapi';
import { Client } from 'openapi-fetch';
import { PathsWithMethod } from 'openapi-typescript-helpers';
import { SWRResponse } from 'swr';

import { ExperienceApiTypes } from '@repo/experience-api-client';
import { useExperienceApiClient } from './useExperienceApiClient';

type Paths = ExperienceApiTypes.paths;

type QueryTypes<Path extends PathsWithMethod<Paths, 'get'>> = TypesForGetRequest<Paths, Path>;

export function useExperienceApiQuery<
  Path extends PathsWithMethod<Paths, 'get'>,
  R extends QueryTypes<Path>,
  Init extends R['Init'],
  Data extends R['Data'],
  Error extends R['Error'],
  Config extends R['SWRConfig'],
>(path: Path, init: Init | null, config?: Config): SWRResponse<Data, Error, Config>;

export function useExperienceApiQuery<
  Path extends PathsWithMethod<Paths, 'get'>,
  R extends QueryTypes<Path>,
  Init extends R['Init'],
  Data extends R['Data'],
  Error extends R['Error'],
  Config extends R['SWRConfig'],
>(path: Path, init?: Init | null, config?: Config): SWRResponse<Data, Error, Config>;

export function useExperienceApiQuery(
  path: PathsWithMethod<Paths, 'get'>,
  init?: unknown,
  config?: unknown,
): unknown {
  const client = useExperienceApiClient() as Client<Paths>;
  const useQuery = createQueryHook(client, 'webapp-api-cache-key');
  return useQuery(path, init as never, config as never);
}
